document.addEventListener('DOMContentLoaded', function () {
  const cartCtas = document.querySelector('.cart__ctas-all');
  const totalValue = document.querySelector('.visual-cart .total-value');
  const visualCartWrapper = document.querySelector('.visual-cart__wrapper');
  const checkoutButton = document.getElementById('checkout');

  if (cartCtas && totalValue) {
    cartCtas.addEventListener('mouseenter', function () {
      totalValue.classList.add('hover');
    });

    cartCtas.addEventListener('mouseleave', function () {
      totalValue.classList.remove('hover');
    });
  }

  if (visualCartWrapper && checkoutButton) {
    visualCartWrapper.style.cursor = 'pointer';

    visualCartWrapper.addEventListener('click', function (event) {
      // Prevent the click from propagating to parent elements
      event.stopPropagation();

      // Trigger the checkout button click
      checkoutButton.click();
    });

    // Prevent the click event on the checkout button from triggering twice
    checkoutButton.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  // Find the two divs
  const cartItemsWrapper = document.querySelector('.cart__items-main-wrapper');
  const cartFooterWrapper = document.querySelector('.cart__footer-wrapper');

  // Check if both divs exist
  if (cartItemsWrapper && cartFooterWrapper) {
    // Create the outer wrapper div
    const outerWrapperDiv = document.createElement('div');
    outerWrapperDiv.id = 'cart-main-wrapper';
    outerWrapperDiv.className = 'cart-main-wrapper';

    // Create the inner wrapper div
    const innerWrapperDiv = document.createElement('div');
    innerWrapperDiv.className = 'cart-main-wrapper__inner';

    // Insert the outer wrapper div before the cart items wrapper
    cartItemsWrapper.parentNode.insertBefore(outerWrapperDiv, cartItemsWrapper);

    // Append the inner wrapper to the outer wrapper
    outerWrapperDiv.appendChild(innerWrapperDiv);

    // Move both original divs into the inner wrapper
    innerWrapperDiv.appendChild(cartItemsWrapper);
    innerWrapperDiv.appendChild(cartFooterWrapper);
  }
});
